"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'CompareSection_1_0_0',
  componentHeadline: 'TABLE COMPARE HEADLINE',
  nextText: 'Next',
  steps: [{
    name: 'Choose your car',
    description: null,
    __typename: 'CompareStep'
  }, {
    name: 'Select models to compare',
    description: 'Choose models that you wish to compare',
    __typename: 'CompareStep'
  }, {
    name: 'Your comparison',
    description: 'View the model comparison',
    __typename: 'CompareStep'
  }],
  carSelector: {
    productTile: [{
      id: '59',
      code: 'ZC',
      year: null,
      codeYear: null,
      price: null,
      vehicleImage: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/D06_ASX.png',
        altText: 'ASX',
        __typename: 'Image'
      },
      vehicleBackgroundImage: {
        image: 'https://www-cms.prod.mipulse.co/content/dam/mitsubishi-motors/images/site-images/backgrounds/car_selector/asx-bg.jpg',
        altText: 'a tree lined road',
        __typename: 'Image'
      },
      name: 'ASX',
      description: '',
      selected: false,
      cta: {
        url: '/en/cars/asx',
        label: 'ASX',
        __typename: 'NavLink'
      },
      buildLink: null,
      tag: {
        code: 'mitsubishi-motors:vehicle-model/tags/offer',
        label: 'Offer',
        __typename: 'Tag'
      },
      selectLabel: 'Selected',
      __typename: 'Vehicle'
    }, {
      id: '11',
      code: 'TQ-MiEV',
      year: null,
      codeYear: null,
      price: null,
      vehicleImage: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/P26_IMiEV.png',
        altText: 'i-MiEV',
        __typename: 'Image'
      },
      vehicleBackgroundImage: {
        image: 'https://www-cms.prod.mipulse.co/content/dam/mitsubishi-motors/images/site-images/backgrounds/car_selector/imiev-bg.jpg',
        altText: 'urban street',
        __typename: 'Image'
      },
      name: 'i-MiEV',
      description: '',
      selected: false,
      cta: {
        url: '/en/cars/i-miev',
        label: 'i-MiEV',
        __typename: 'NavLink'
      },
      buildLink: null,
      tag: null,
      selectLabel: 'Selected',
      __typename: 'Vehicle'
    }, {
      id: '104',
      code: 'RE-PHEV',
      year: null,
      codeYear: null,
      price: null,
      vehicleImage: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/W37_Outlander-PHEV.png',
        altText: 'Outlander PHEV',
        __typename: 'Image'
      },
      vehicleBackgroundImage: {
        image: 'https://www-cms.prod.mipulse.co/content/dam/mitsubishi-motors/images/site-images/backgrounds/car_selector/outlander-phev-bg.jpg',
        altText: 'pedestrian crossing',
        __typename: 'Image'
      },
      name: 'OUTLANDER PHEV',
      description: '',
      selected: false,
      cta: {
        url: '/en/cars/outlander-phev',
        label: 'OUTLANDER PHEV',
        __typename: 'NavLink'
      },
      buildLink: null,
      tag: {
        code: 'mitsubishi-motors:vehicle-model/tags/offer',
        label: 'Offer',
        __typename: 'Tag'
      },
      selectLabel: 'Selected',
      __typename: 'Vehicle'
    }, {
      id: '38',
      code: 'RE',
      year: null,
      codeYear: null,
      price: null,
      vehicleImage: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/P26_Outlander.png',
        altText: 'Outlander ',
        __typename: 'Image'
      },
      vehicleBackgroundImage: {
        image: 'https://www-cms.prod.mipulse.co/content/dam/mitsubishi-motors/images/site-images/backgrounds/car_selector/outlander-bg.jpg',
        altText: 'snowy mountain',
        __typename: 'Image'
      },
      name: 'OUTLANDER',
      description: '',
      selected: false,
      cta: {
        url: '/en/cars/outlander',
        label: 'OUTLANDER',
        __typename: 'NavLink'
      },
      buildLink: null,
      tag: null,
      selectLabel: 'Selected',
      __typename: 'Vehicle'
    }, {
      id: '19',
      code: 'NS',
      year: null,
      codeYear: null,
      price: null,
      vehicleImage: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/P62_Eclipse-Cross.png',
        altText: 'ECLIPSE CROSS',
        __typename: 'Image'
      },
      vehicleBackgroundImage: {
        image: 'https://www-cms.prod.mipulse.co/content/dam/mitsubishi-motors/images/site-images/backgrounds/car_selector/eclipse-cross-bg.jpg',
        altText: 'urban street',
        __typename: 'Image'
      },
      name: 'Eclipse Cross',
      description: '',
      selected: false,
      cta: {
        url: '/en/cars/eclipse-cross',
        label: 'Eclipse Cross',
        __typename: 'NavLink'
      },
      buildLink: null,
      tag: null,
      selectLabel: 'Selected',
      __typename: 'Vehicle'
    }, {
      id: '35',
      code: 'QX',
      year: null,
      codeYear: null,
      price: null,
      vehicleImage: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/U25_Shogun-Sport.png',
        altText: 'Shogun Sport',
        __typename: 'Image'
      },
      vehicleBackgroundImage: {
        image: 'https://www-cms.prod.mipulse.co/content/dam/mitsubishi-motors/images/site-images/backgrounds/car_selector/shogun-sport-bg.jpg',
        altText: 'desert road',
        __typename: 'Image'
      },
      name: 'MONTERO SPORT',
      description: '',
      selected: false,
      cta: {
        url: '/en/cars/pajero-sport',
        label: 'MONTERO SPORT',
        __typename: 'NavLink'
      },
      buildLink: null,
      tag: null,
      selectLabel: 'Selected',
      __typename: 'Vehicle'
    }, {
      id: '14',
      code: 'SU',
      year: null,
      codeYear: null,
      price: null,
      vehicleImage: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/U25_L200-DC.png',
        altText: 'L200',
        __typename: 'Image'
      },
      vehicleBackgroundImage: {
        image: 'https://www-cms.prod.mipulse.co/content/dam/mitsubishi-motors/images/site-images/backgrounds/car_selector/l200-dc-bg.jpg',
        altText: 'hut in a field',
        __typename: 'Image'
      },
      name: 'L200',
      description: '',
      selected: false,
      cta: {
        url: '/en/cars/l200',
        label: 'L200',
        __typename: 'NavLink'
      },
      buildLink: null,
      tag: null,
      selectLabel: 'Selected',
      __typename: 'Vehicle'
    }, {
      id: '8',
      code: 'EL-L',
      year: null,
      codeYear: null,
      price: null,
      vehicleImage: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/W54_Attrage.png',
        altText: 'attrage on a city street',
        __typename: 'Image'
      },
      vehicleBackgroundImage: {
        image: 'https://www-cms.prod.mipulse.co/content/dam/mitsubishi-motors/images/site-images/backgrounds/car_selector/attrage-bg.jpg',
        altText: 'sunlight by a city lake',
        __typename: 'Image'
      },
      name: 'Attrage',
      description: '',
      selected: false,
      cta: {
        url: '/en/cars/attrage',
        label: 'Attrage',
        __typename: 'NavLink'
      },
      buildLink: null,
      tag: null,
      selectLabel: 'Selected',
      __typename: 'Vehicle'
    }, {
      id: '54',
      code: 'EL',
      year: null,
      codeYear: null,
      price: null,
      vehicleImage: {
        image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/P57_Mirage.png',
        altText: 'Mirage',
        __typename: 'Image'
      },
      vehicleBackgroundImage: {
        image: 'https://www-cms.prod.mipulse.co/content/dam/mitsubishi-motors/images/site-images/backgrounds/car_selector/mirage-bg-2.jpg',
        altText: 'Urban street',
        __typename: 'Image'
      },
      name: 'Mirage',
      description: '',
      selected: false,
      cta: {
        url: '/en/cars/space-star',
        label: 'Mirage',
        __typename: 'NavLink'
      },
      buildLink: null,
      tag: null,
      selectLabel: 'Selected',
      __typename: 'Vehicle'
    }],
    __typename: 'CarSelector'
  },
  __typename: 'CompareSection'
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;